module.exports = __webpack_public_path__ + "media/images/category_icons/category_icon_4-44d7a6cd0fbe4b6906f8d6dd7c4c34c2.svg";